export default __webpack_public_path__ + "static/media/illustration-algostudy-n-m@2x.03b3b6f0.webp";